import { useRef, useLayoutEffect } from 'react'
import { useMarketplace } from '../context'
import filtersIcon from 'bundle-text:../assets/icons/filters.svg'
import { Search } from './Search'
import { useCollection } from '../api/collection'
import { Sorting } from './Sorting'

export function Controls() {
    const { toggleUI } = useMarketplace()
    const { data } = useCollection()
    const totalItems = data?.pages[0].total_items || 0
    const ref = useRef<HTMLDivElement>(null)
    useLayoutEffect(() => {
        if (!ref.current) return
        const ro = new ResizeObserver(() => {
            document.documentElement.style.setProperty(
                '--marketplace-controls-height',
                `${ref.current.getBoundingClientRect().height}px`
            )
        })
        ro.observe(ref.current)
        return () => ro.disconnect()
    }, [])
    return (
        <div
            ref={ref}
            className='sticky md:static top-[var(--page-menu-height)] md:top-0 z-[49] flex flex-row w-full  items-center p-4 gap-4 bg-black'
        >
            <button
                onClick={() => toggleUI('filtersOpen')}
                className='md:hidden rounded bg-white/10 p-2'
                dangerouslySetInnerHTML={{ __html: filtersIcon }}
            ></button>
            <Search />
            <Sorting />
            <div className='font-bold text-white'>{totalItems}</div>
        </div>
    )
}
